import { render, staticRenderFns } from "./form-switch.vue?vue&type=template&id=7454d285&scoped=true"
import script from "./form-switch.ts?vue&type=script&lang=ts&external"
export * from "./form-switch.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454d285",
  null
  
)

export default component.exports